import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import './index.css';
import { NavbarCompo } from './presentation/components';
import { MantineProvider } from '@mantine/core';
import AnimatedRoutesCompo from './presentation/components/animatedRoutes/animatedroutes-component';
function App() {
  return (
    <MantineProvider
      withGlobalStyles
      withNormalizeCSS
      theme={{ fontFamily: 'Nunito Sans, sans serif', loader: 'bars' }}
    >
      <div className="App">
        <Router>
          <NavbarCompo />
          <AnimatedRoutesCompo />
        </Router>
      </div>
    </MantineProvider>
  );
}

export default App;
